import * as React from "react";
import CheckMarkerIcon from "../../../assets/svg/check_marker.svg";
import {checkMarker} from "./check-marker.module.css";

const CheckMarker = () => {
    return <CheckMarkerIcon className={checkMarker} />;
};

export default CheckMarker;
